import { SOUND_EDITION_V2_ABI } from '../abi/sound-edition-v2.mjs';
import { interfaceIds } from '../interfaceIds.mjs';

function isSoundV2(client, {
  editionAddress
}) {
  return client.readContract({
    abi: SOUND_EDITION_V2_ABI,
    address: editionAddress,
    functionName: "supportsInterface",
    args: [interfaceIds.ISoundEditionV2]
  });
}

export { isSoundV2 };
